export const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const phonePattern = /^\d{8}$/;

export const normalizeWhitespace = (value: string): string => value.trim();

/**
 * Normalizes a phone number by removing +45 prefix and all whitespace/special characters
 * Examples:
 * - "+45 12 34 56 78" -> "12345678"
 * - "12-34-56-78" -> "12345678"
 * - " 12345678 " -> "12345678"
 */
export const normalizePhone = (value: string): string => {
  // Remove all whitespace and special characters
  let normalized = value.replace(/[\s\-\(\)]/g, '');

  // Remove +45 prefix if present
  if (normalized.startsWith('+45')) {
    normalized = normalized.substring(3);
  } else if (normalized.startsWith('0045')) {
    normalized = normalized.substring(4);
  }

  return normalized;
};

export const isValidEmail = (value: string): boolean => {
  const normalized = normalizeWhitespace(value);
  if (!normalized) {
    return false;
  }
  return emailPattern.test(normalized.toLowerCase());
};

export const isValidPhone = (value: string): boolean => {
  const normalized = normalizePhone(value);
  if (!normalized) {
    return false;
  }
  return phonePattern.test(normalized);
};
